export default "__VITE_ASSET__C25EIxd7__"